import { render } from "./p-draggable.vue?vue&type=template&id=ffb43ae0&scoped=true"
import script from "./p-draggable.vue?vue&type=script&lang=js"
export * from "./p-draggable.vue?vue&type=script&lang=js"

import "./p-draggable.vue?vue&type=style&index=0&id=ffb43ae0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb43ae0"],['__file',"src/components/p-draggable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffb43ae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffb43ae0', __exports__)) {
    api.reload('ffb43ae0', __exports__)
  }
  
  module.hot.accept("./p-draggable.vue?vue&type=template&id=ffb43ae0&scoped=true", () => {
    api.rerender('ffb43ae0', render)
  })

}


export default __exports__